import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
}

export async function ensurePushSubscription() {
    try {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
        const reg = await navigator.serviceWorker.register("/sw.js");
        await navigator.serviceWorker.ready;
        let perm = Notification.permission;
        if (perm === "default") perm = await Notification.requestPermission();
        if (perm !== "granted") return;
        let sub = await reg.pushManager.getSubscription();
        if (!sub) {
            const { data } = await api.get("/push/public-key");
            if (!data.public_key) return;
            sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(data.public_key),
            });
        }
        const raw = sub.toJSON();
        await api.post("/push/subscribe", {
            endpoint: raw.endpoint,
            keys: raw.keys,
        });
        // SW → main navigation handler
        navigator.serviceWorker.addEventListener("message", (e) => {
            if (e.data?.type === "navigate" && e.data.url) window.location.href = e.data.url;
        });
    } catch (e) { console.warn("push subscribe failed", e); }
}
